import { styled, css } from '@mui/material/styles';

const dynamicSvgColor = ({ svgColor }) =>
  svgColor &&
  css`
    stroke: ${svgColor};
  `;

export const StyledIcon = styled('span')(
  ({ svgColor }) => `
    display: flex;
    align-items: center;
  
    svg {
      stroke: currentColor;
      ${dynamicSvgColor({ svgColor })};
    }
  `,
);

export const StyledLinkWrapper = styled('span')`
  margin-left: 10px;
`;

const dynamicTextColor = ({ textColor }) =>
  textColor &&
  css`
    color: ${textColor || 'currentColor'};
  `;

const dynamicInline = ({ isInline }) =>
  isInline &&
  css`
    display: inline;
    margin: 0 4px;

    span {
      margin-left: 0;
    }
  `;

export const SocialLinkWrapper = styled('span')(
  ({ textColor, isInline }) => `
    display: inline-flex;
    justify-content: center;
    align-items: center;
    ${dynamicTextColor({ textColor })};
    ${dynamicInline({ isInline })};
  `,
);
